import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  styled,
  Typography,
} from "@mui/material";
import { ArrowRight } from "@mui/icons-material";

import { LegendLoad } from "./LegendLoad";
import { ExtendedWMSParams } from "types/types";

interface Props {
  wms: ExtendedWMSParams;
  label: string;
  id: number;
  attribution?: string;
}

export function LegendAccordion(props: Props) {
  const { wms, label, id, attribution } = props;

  return (
    <StyledAccordion elevation={0} disableGutters defaultExpanded>
      <AccordionSummary expandIcon={<ArrowRight />}>
        <Typography variant="subtitle1">{label}</Typography>
        {attribution && (
          <Typography variant="small-italic">{attribution}</Typography>
        )}
      </AccordionSummary>
      <AccordionDetails>
        <LegendLoad wmsParams={wms} url={wms.url} id={id} />
      </AccordionDetails>
    </StyledAccordion>
  );
}

const StyledAccordion = styled(Accordion)`
  .MuiAccordionDetails-root {
    min-height: ${({ theme }) => theme.spacing(4)};
    padding: 0;
  }
  &.MuiAccordion-root::before {
    visibility: hidden;
  }
  &.MuiAccordion-root {
    background-color: transparent;
  }
  .MuiAccordionSummary-expandIconWrapper {
    transition: transform 320ms ease-out;
    margin-top: 2px;
    &.Mui-expanded {
      transform: rotate(90deg);
    }
  }

  .MuiCollapse-root {
    margin-top: ${({ theme }) => theme.spacing(1)};
  }

  .MuiAccordionSummary-root {
    padding: 0;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: flex-start;
    gap: ${({ theme }) => theme.spacing(1)};
    min-height: 20px;
  }
  .MuiAccordionSummary-content {
    margin: 0;
    display: flex;
    flex-direction: column;
  }
`;
